// import { $get, $post, $patch, $put, $delete } from '_library/ajax'
import { $get, $post } from '_library/ajax'

const list = {
  'popup-process-page-list': '/popup/process/page-list',
  'add-popup-process-to-public': '/popup/process/add-to-public',
  'delete-popup-process-from-public': '/popup/process/delete-from-public',
}

const methods = {
  fetchPopupProcessList: data => $get('popup-process-page-list', data), // 获取弹窗进程数据列表（分页）
  addPopupProcessToPublic: data => $post('add-popup-process-to-public', data), // 添加客户端弹窗进程数据到公共弹窗进程数据
  deletePopupProcessFromPublic: data =>
    $post('delete-popup-process-from-public', data), // 将弹窗进程数据从公共弹窗进程数据中删除
}

export default { list, methods }
